// eslint-disable-next-line react/no-deprecated
import { render } from "react-dom";
import Dashboard from "./Dashboard";
import "./../frontend/registration-form/style.scss";

import { Provider } from "react-redux";
import { store } from "./app/store";

// src/frontend/registration-form/style.scss
document.addEventListener("DOMContentLoaded", () => {
  const dom = document.getElementById("member_dashboard");
  render(
    <Provider store={store}>
      <Dashboard nonce={dom.dataset.nonce} />
    </Provider>,
    dom
  );
});
